export default __webpack_public_path__ + "static/media/associate-img.71070807.png";